import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import StoreInformation from './businessDNA/StoreInformation';
import Audience from './businessDNA/Audience';
import BrandFundamentals from './businessDNA/BrandFundamentals';
import BrandPersonality from './businessDNA/BrandPersonality';
import SEOFoundation from './businessDNA/SEOFoundation';
import BrandImage from './businessDNA/BrandImage';
import Products from './businessDNA/Products';
import Competitors from './businessDNA/Competitors';

function BusinessDNA() {
  const [progress, setProgress] = useState({
    storeInformation: false,
    audience: false,
    brandFundamentals: false,
    brandPersonality: false,
    seoFoundation: false,
    brandImage: false,
    products: false,
    competitors: false
  });

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-semibold">Business DNA</h1>
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-500">0 Free Generations Left</span>
            <span className="text-amber-500">⚠️</span>
            <div className="flex items-center space-x-2 ml-4">
              <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center">
                S
              </div>
              <span className="text-sm">Hello, Salim</span>
              <ChevronDownIcon className="h-4 w-4 text-gray-500" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {/* Left Column - Form Sections */}
          <div className="col-span-2 space-y-6">
            <StoreInformation onComplete={(completed) => setProgress(prev => ({ ...prev, storeInformation: completed }))} />
            <Audience onComplete={(completed) => setProgress(prev => ({ ...prev, audience: completed }))} />
            <BrandFundamentals onComplete={(completed) => setProgress(prev => ({ ...prev, brandFundamentals: completed }))} />
            <BrandPersonality onComplete={(completed) => setProgress(prev => ({ ...prev, brandPersonality: completed }))} />
            <Products onComplete={(completed) => setProgress(prev => ({ ...prev, products: completed }))} />
            <SEOFoundation onComplete={(completed) => setProgress(prev => ({ ...prev, seoFoundation: completed }))} />
            <Competitors onComplete={(completed) => setProgress(prev => ({ ...prev, competitors: completed }))} />
            <BrandImage onComplete={(completed) => setProgress(prev => ({ ...prev, brandImage: completed }))} />
          </div>

          {/* Right Column - Progress */}
          <div className="bg-white rounded-lg p-6 shadow-sm h-fit sticky top-8">
            <h2 className="text-lg font-medium mb-4">Profile Completion</h2>
            <p className="text-sm text-gray-600 mb-6">Complete all sections listed below to enable Glowtify work its magic!</p>
            
            <div className="space-y-3">
              {Object.entries(progress).map(([key, completed]) => (
                <div
                  key={key}
                  className={`flex items-center p-3 rounded-lg ${
                    completed ? 'bg-green-50 text-green-700' : 'bg-gray-50'
                  }`}
                >
                  <span className="text-sm">
                    {key.replace(/([A-Z])/g, ' $1').split(' ').map(word => 
                      word.charAt(0).toUpperCase() + word.slice(1)
                    ).join(' ')}
                  </span>
                  {completed && (
                    <svg className="w-5 h-5 ml-auto" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessDNA;